// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './Spinner.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Spinner = (props: Props) => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='spinnerComponent' className={cx('spinnerContainer')}>
      <Box className={cx('spinner')}></Box>
    </Box>
  );
};

export default Spinner;
